:host {
    display: flex;
    justify-content: center;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    vm-icon {
        display: block;
        animation: spin 0.75s infinite linear;
    }
}
